module.exports = __webpack_public_path__ + "img/08-min.39bd9fa1.jpg";